'use client';

import { useEffect, useState } from 'react';
import { Checkbox } from '@terra/ui-design-system';
import { Box } from '@terra/ui-styled-system';
import type { ICellRendererParams, IRowNode } from 'ag-grid-community';
import type { HARRequest } from '../../hooks/api/mapHarEntryToHarRequest';

const subscribeToRowSelected = ({
  node,
  onSelected,
}: {
  node: IRowNode<HARRequest>;
  onSelected: () => void;
}): (() => void) => {
  node.addEventListener('rowSelected', onSelected);

  return () => {
    node.removeEventListener('rowSelected', onSelected);
  };
};

export function RequestsSelectionCheckboxCell({
  node,
  data,
}: ICellRendererParams<HARRequest>) {
  const [selected, setSelected] = useState(() => node.isSelected() === true);

  useEffect(() => {
    const syncSelected = () => {
      setSelected(node.isSelected() === true);
    };

    syncSelected();

    return subscribeToRowSelected({ node, onSelected: syncSelected });
  }, [node]);

  if (!data) {
    return null;
  }

  return (
    <Box
      w="full"
      h="full"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Checkbox
        size="sm"
        checked={selected}
        onClick={(event) => event.stopPropagation()}
        onCheckedChange={(details) => {
          node.setSelected(details.checked === true, false, 'checkboxSelected');
        }}
      />
    </Box>
  );
}
